import { LoginLogo } from "@/features/auth/components/LoginLogo";
import { RecoverForm } from "@/features/auth/components/RecoverForm";
import { Stack, Typography } from "@mui/material";
import { FC } from "react";

type TRecoverPageProps = {};

export const RecoverPage: FC<TRecoverPageProps> = () => {
  return (
    <Stack gap={6} alignItems="center">
      <LoginLogo />
      <Typography variant="head24Semi">パスワード再発行</Typography>
      <RecoverForm />
    </Stack>
  );
};
